/**
 * Planification différée du site public. Seul module autorisé à appeler les
 * timers natifs ; reprend les noms de Turbo.FrontEnd (`AsyncUtils`) sans ses
 * dépendances (stores, jQuery, Kendo).
 */
export abstract class AsyncUtils {
  /** Exécute `handler` après `delay` ms et renvoie l'identifiant de la tâche. */
  static setDeferredExecution(handler: () => void, delay: number): number {
    return window.setTimeout(handler, Math.max(0, delay));
  }

  /** Annule une tâche planifiée ; sans effet si l'identifiant est absent. */
  static clearPendingDeferredExecution(id: number | undefined): void {
    if (id !== undefined) {
      window.clearTimeout(id);
    }
  }
}
